import PropTypes from 'prop-types';
import React from 'react';
import { Briefcase, Pencil } from 'lucide-react';
import { formatWorkDates } from 'helpers/portfolioLayout';
import styles from '../../CareerEntries.module.scss';

const WorkExperienceDetails = ({
  workExperience,
  onEdit,
  isOwn,
  user,
  compact,
  expanded,
}) => {
  const dates = formatWorkDates(
    workExperience.start_date,
    workExperience.end_date
  );

  const title = (
    <span className={compact ? styles.compactTitle : styles.title}>
      {workExperience.job_title}
      {workExperience.company_name && (
        <span className={styles.issuer}> · {workExperience.company_name}</span>
      )}
    </span>
  );

  const editButton = user && isOwn && (
    <button
      type="button"
      className={styles.editEntryBtn}
      onClick={onEdit}
      aria-label={`Edit ${
        [workExperience.job_title, workExperience.company_name]
          .filter(Boolean)
          .join(' at ') || 'role'
      }`}
    >
      <Pencil size={15} strokeWidth={2} aria-hidden="true" />
    </button>
  );

  if (compact) {
    return (
      <div className={`${styles.entry} ${styles.entryCentered}`}>
        <span className={styles.iconSlot} aria-hidden="true">
          <span className={`${styles.iconTile} ${styles.iconTileSmall}`}>
            <Briefcase size={14} strokeWidth={2} />
          </span>
        </span>
        <div className={styles.body}>
          <div className={styles.titleRow}>
            {title}
            <span className={styles.dates}>{dates}</span>
          </div>
        </div>
        {editButton}
      </div>
    );
  }

  return (
    <div className={styles.entry}>
      <span className={styles.iconTile} aria-hidden="true">
        <Briefcase size={18} strokeWidth={2} />
      </span>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          {title}
          <span className={styles.dates}>{dates}</span>
        </div>
        {workExperience.description && (
          <p
            className={`${styles.description} ${
              expanded ? styles.descriptionOpen : ''
            }`}
          >
            {workExperience.description}
          </p>
        )}
      </div>
      {editButton}
    </div>
  );
};

WorkExperienceDetails.propTypes = {
  workExperience: PropTypes.object,
  onEdit: PropTypes.func,
  isOwn: PropTypes.bool,
  user: PropTypes.object,
  compact: PropTypes.bool,
  expanded: PropTypes.bool,
};

export default WorkExperienceDetails;
